import axiosClient from '../interceptors';
import {ApiRoutes} from "../routes/ApiRoutes";
import {getAPIUrl} from "./BaseService";
import {ApiResponse, GradingSystemEntity} from "../types";

interface GradeInput {
    name: string;
    score: {
        max_score: number;
        min_score: number;
    };
}

interface AssessmentInput {
    name: string;
    allocation: {
        allocation_percent: number;
    };
}

interface BehaviourInput {
    name: string;
}

export async function updateOrCreateGradingSystem(
    gradingSystemName: string,
    gradeSystemGrades: GradeInput[],
    gradeSystemAssessments: AssessmentInput[],
    gradeSystemBehaviours: BehaviourInput[],
    gradingSystemId: string | null = null
): Promise<ApiResponse<GradingSystemEntity>> {
    const formattedBody = {
        uuid: gradingSystemId,
        name: gradingSystemName,
        grades: gradeSystemGrades.map((grade) => ({
            name: grade.name,
            max_score: grade.score.max_score,
            min_score: grade.score.min_score,
        })),
        assessments: gradeSystemAssessments.map((assessment) => ({
            name: assessment.name,
            allocation_percent: assessment.allocation.allocation_percent,
        })),
        behaviours: gradeSystemBehaviours.map((behaviour) => behaviour.name),
    };

    const url = getAPIUrl() + ApiRoutes.GRADING_SYSTEM;
    const response = await axiosClient.post<ApiResponse<GradingSystemEntity>>(url, formattedBody);
    return response.data;
}

export async function getGradingSystems(): Promise<ApiResponse<GradingSystemEntity[]>> {
    const url = getAPIUrl() + ApiRoutes.GRADING_SYSTEMS;
    const response = await axiosClient.get<GradingSystemEntity[]>(url);
    return {
        status: 'success',
        data: response.data,
    };
}
